// extracted by mini-css-extract-plugin
export default {"alert":"UnrevealError_alert__bu00P"};